import React from "react";
import { BeatLoader } from "react-spinners";

function Loader(){
    return <div className="loader-overlay">
                <div className='loader-container'>
                    <BeatLoader color="#C6153B"/>
                </div>
            </div>
}export default Loader